import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { ctaLinkStyles } from './cta.style.js';
import { InlineStyles } from './inline.style.js';
import { StandaloneStyles } from './standalone.style.js';

const styles = (props) => {
    switch (props.type) {
        case 'inline':
            return InlineStyles;
        case 'CTA':
            return ctaLinkStyles;
        default:
            return StandaloneStyles;
    }
};
const InternalLink = styled((_a) => {
    var /* eslint-enable */
    props = __rest(_a, ["backgroundColor", "backgroundless", "fullWidth", "textAlign", "whiteSpace"]);
    return jsx(Link, Object.assign({}, props), void 0);
}) `
  ${props => styles(props)}
`;
const ExternalLink = styled.a `
  ${props => styles(props)}
`;

export { ExternalLink, InternalLink, styles };
